import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import OrderHead from "@/shared/model/orderHead";
import OrderHeadComponent from "@/modules/Order/components/OrderHeadComponent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import Payment from "@/shared/model/Payment";

interface Props {
  orderHead?: OrderHead
  payment?: Payment
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderHeadCardComponent',
  props: {
    orderHead: { default: undefined },
    payment: { default: undefined }
  },
  setup(__props: any) {


const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.orderHead.orderNumber), 1)
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(OrderHeadComponent, {
            "order-head": __props.orderHead,
            payment: __props.payment
          }, null, 8, ["order-head", "payment"])
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})